<template>
  <Loading v-if="isLoading"/>
  <div class="container" v-else>
    <div class="row">
      <div class="col-12 content">
        <h1>{{$t('download_page_for_non_commercial')}}</h1>
        <hr>
        <div class="confirmation">
          <div class="img-dl" v-if="images_download !== null">
            <h2><span>{{$t('download_photographs')}}</span></h2>
            <div class="dl-btn">
              <a @click="trackingDownloadImages(images_codes)" :href="images_download" target="_blank">{{$t('download_zip')}}</a>
            </div>
          </div>
          <div v-if="movies_download.length > 0" class="movie-dl">
            <h2><span>{{$t('download_videos')}}</span></h2>
            <ul>
              <li v-for="(movie,index) in movies_download" :key="index"><div class="movie-name">{{movie.title}}<span></span>
                <a @click="trackingDownloadMove(movie.code)" :href="movie.download_link"  target="_blank">{{$t('download')}}</a>
              </div></li>
            </ul>
          </div>
          <hr>
          <div class="back-to-search">
            <router-link :to="{name: 'ArtifactsList'}">{{$t('return_to_the_archives')}}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../components/Loading";
import axios from "axios";

export default {
  name: "AssetNonCommercialDownload",
  components: {Loading},
  mounted() {
    window.history.scrollRestoration = "manual"
    window.scrollTo(0, 0)
  },
  computed: {
    isEmptyCart() {
      if (localStorage.getItem('cart')) return false
      return true
    }
  },
  data() {
    return {
      isLoading: false,
      lang: lang,
      cart: localStorage.getItem('cart'),
      images_download: null,
      images_codes: null,
      movies_download: []
    }
  },
  created() {
    this.getDownloadList()
  },
  methods: {
    trackingDownloadImages (images) {
      if(images !== null){
        let ids = images.split(',')
        ids.forEach(id => {
          this.$gtag.event('download', {
            'event_category': 'Images',
            'event_label': '[' + this.lang.toUpperCase() + ']' + id,
            'value': 1
            })
        })
      }
    },
    trackingDownloadMove (movie) {
      if(movie !== null){
        this.$gtag.event('download', {
          'event_category': 'Movies',
          'event_label': movie,
          'value': 1
        })
      }
    },
    getDownloadList() {
      this.isLoading = true
      const config = {
        params: {
          ids: this.cart,
        }
      }
      axios.get('/api/archives/assets-download-link', config)
          .then((res) => {
            this.images_download = res.data.images_download
            this.movies_download = res.data.movies_download
            this.images_codes = res.data.images_codes
            localStorage.removeItem('cart')
          })
          .finally(() => {
            this.isLoading = false
          })
    }
  }
}
</script>

<style scoped>

</style>
